import type { DiagramRevision } from '../../store/types.ts';

type RevisionHistoryProps = {
  revisions: Array<DiagramRevision & { index: number }>;
  currentCursor: number;
  canUndo: boolean;
  canRedo: boolean;
  onUndo: () => void;
  onRedo: () => void;
  onRestore: (index: number) => void;
};

export function RevisionHistory({
  revisions,
  currentCursor,
  canUndo,
  canRedo,
  onUndo,
  onRedo,
  onRestore,
}: RevisionHistoryProps) {
  return (
    <div className="ds-revisions">
      <div className="ds-revisions__head">
        <span className="ds-revisions__title">Revision History</span>
        <div className="ds-revisions__actions">
          <button type="button" className="ds-btn ds-btn--sm ds-btn--ghost" onClick={onUndo} disabled={!canUndo}>
            Undo
          </button>
          <button type="button" className="ds-btn ds-btn--sm ds-btn--ghost" onClick={onRedo} disabled={!canRedo}>
            Redo
          </button>
        </div>
      </div>

      {revisions.map((revision) => (
        <div
          key={revision.id}
          className={`ds-revision ${currentCursor === revision.index ? 'ds-revision--active' : ''}`}
        >
          <div className="ds-revision__meta">
            <span className="ds-revision__note">{revision.note}</span>
            <span className="ds-revision__info">
              {revision.source} · {new Date(revision.createdAt).toLocaleTimeString()}
            </span>
          </div>
          <button
            type="button"
            className="ds-btn ds-btn--sm ds-btn--ghost"
            onClick={() => onRestore(revision.index)}
            disabled={currentCursor === revision.index}
          >
            {currentCursor === revision.index ? 'Current' : 'Restore'}
          </button>
        </div>
      ))}
    </div>
  );
}
